"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StockFilterOption = void 0;
const mobx_1 = require("mobx");
class StockFilterOption {
    constructor() {
        this.showOnlyInStock = true;
        this.reset = () => {
            this.showOnlyInStock = true;
        };
        this.shouldBeFiltered = (listing) => {
            const { trackInventory, quantity } = listing;
            const inventoryTrackedAndHasStock = trackInventory && quantity > 0;
            return !trackInventory || inventoryTrackedAndHasStock;
        };
    }
    setShowOnlyInStock(show) {
        this.showOnlyInStock = show;
    }
}
__decorate([
    mobx_1.observable,
    __metadata("design:type", Object)
], StockFilterOption.prototype, "showOnlyInStock", void 0);
__decorate([
    mobx_1.action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], StockFilterOption.prototype, "setShowOnlyInStock", null);
__decorate([
    mobx_1.action,
    __metadata("design:type", Object)
], StockFilterOption.prototype, "reset", void 0);
exports.StockFilterOption = StockFilterOption;
//# sourceMappingURL=StockFilterOption.js.map